// extracted by mini-css-extract-plugin
export default {"zoomModal":"U1-z","image":"V1-z","button":"W1-z","isOverlayShown":"X1-z"};